import { FC, useState } from 'react';

import { SvgIconName } from '~src/shared/SvgIcon';

import IconField from './IconField';

interface Props {
  iconName: SvgIconName;
  children: (selected: boolean, select: () => void, blur: () => void) => JSX.Element;
  hoverTextKey?: string;
  iconClick?: () => void;
  viewBoxWidth?: number;
  viewBoxHeight?: number;
}

const SelectorHandler: FC<Props> = props => {
  const [selected, setSelected] = useState(false);

  const select = () => {
    setSelected(true);
  };

  const blur = () => {
    setSelected(false);
  };

  return (
    <IconField
      hoverTextKey={props.hoverTextKey}
      iconClick={props.iconClick}
      selected={selected}
      iconName={props.iconName}
      viewBoxWidth={props.viewBoxWidth}
      viewBoxHeight={props.viewBoxHeight}
    >
      {props.children(selected, select, blur)}
    </IconField>
  );
};

export default SelectorHandler;
